export const environment = {
  production: false,
  enableLocalS3PresignedUrlRewrite: true,
  s3PresignedUrlInternalOrigin: "http://ministack:4566",
  s3PresignedUrlBrowserOrigin: "http://localhost:4566",
  bypassAuthorization: false, // Set to false to enforce authorization locally
  apiUrl: "/api",
  jiraProjectKeyEndpoint: "END", // Jira project key for Endpoint Security dashboard
  slackWorkspaceUrl: "https://simetriksupport.slack.com", // Slack workspace URL
};
